const ContinuityOfCareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.4728 29.8132L49.001 35.0023C48.9299 35.7852 49.1334 36.5684 49.5768 37.2175L51.9557 40.7004C52.6067 41.6536 52.9007 42.8059 52.786 43.9545L51.3473 58.3586C51.2339 59.493 50.2793 60.357 49.1391 60.357C47.8342 60.357 46.811 59.2366 46.9291 57.9371L47.7886 48.4839C47.9326 46.8995 47.2992 45.3436 46.0896 44.3102L38.231 37.5969C36.7807 36.358 35.9456 34.5462 35.9456 32.6388C35.9456 30.0337 36.6901 27.4829 38.0915 25.2868L43.1152 17.4142C44.5329 15.1925 47.4923 14.5567 49.6974 16L51.7531 17.3455C52.9807 18.1489 53.7866 19.4572 53.952 20.9149L54.6541 27.1026C54.7903 28.3028 55.4934 29.3651 56.5451 29.9594L60.3907 32.1328C61.1307 32.551 61.4374 33.459 61.1026 34.2402C60.7158 35.1426 59.6368 35.5168 58.7744 35.0478L53.5899 32.2283C52.6371 31.7102 51.9536 30.8068 51.7141 29.7491L50.3455 23.7045"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6396 43.0621L39.2304 58.7677C38.9048 59.7131 38.0151 60.3476 37.0152 60.3476C35.3968 60.3476 34.2658 58.7458 34.8075 57.2208L40.9545 39.9141"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4185 42.2567L13.798 43.6451C13.647 43.983 13.7266 44.3796 13.9964 44.633L17.9085 48.3078C18.1889 48.5712 18.3558 48.9334 18.3739 49.3177L18.7893 58.1409C18.8461 59.3461 17.8842 60.3542 16.6777 60.3542C15.5448 60.3542 14.6134 59.4613 14.5656 58.3295L14.249 50.8341C14.2304 50.3929 14.0159 49.983 13.664 49.7162L9.19434 46.328C6.61447 44.3723 5.9026 40.7975 7.53651 38.0028L11.8404 30.6412C12.3407 29.7854 13.4392 29.4957 14.2965 29.9934L16.8383 31.4689C17.8575 32.0606 18.4728 33.1609 18.4434 34.339L18.3575 37.7742C18.3515 38.0152 18.572 38.1987 18.8079 38.149L22.4131 37.3901C23.2091 37.2225 23.9845 37.7518 24.1182 38.5543C24.2295 39.2222 23.8571 39.8766 23.226 40.1221L18.4263 41.9885C17.3621 42.4024 16.1705 41.8242 15.837 40.7321L14.4912 36.3247"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0698 48.5L12.1721 51.215C12.2103 52.2295 11.5717 53.1465 10.6069 53.4626L3.30278 55.8553C2.36072 56.1639 1.35013 55.632 1.07128 54.6808C0.807628 53.7814 1.29695 52.8335 2.18286 52.5274L8.0263 50.5089C8.35414 50.3956 8.54624 50.0559 8.47429 49.7166L7.23381 43.8672"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.909 39.4072C57.909 39.4072 57.8045 35.8438 60.4693 35.8438C63.134 35.8438 62.999 39.4072 62.999 39.4072V60.3515"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6717 21.4843L19.5875 20.9499C18.5678 20.6885 17.5293 21.3031 17.2678 22.3228L16.1193 26.8019C15.8579 27.8216 16.4725 28.8601 17.4922 29.1215L19.5764 29.6559C20.596 29.9173 21.6346 29.3027 21.896 28.283L23.0446 23.8039C23.306 22.7842 22.6913 21.7457 21.6717 21.4843Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.6378 4H52.2356C51.1829 4 50.3296 4.85331 50.3296 5.90593V12.2991C50.3296 13.3517 51.1829 14.205 52.2356 14.205H55.6378C56.6905 14.205 57.5438 13.3517 57.5438 12.2991V5.90593C57.5438 4.85331 56.6905 4 55.6378 4Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ContinuityOfCareIcon;
